import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot, ActivatedRoute } from '@angular/router';
import { Observable, of, EMPTY } from 'rxjs';
import { mergeMap, take } from 'rxjs/operators';
import { SalesService, SubmissionService } from '.';

@Injectable({
  providedIn: 'root',
})
export class PartialResolverService  {
  constructor(private salesService: SalesService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Observable<never> {
    const id = route.queryParamMap.get('id');
    const step = route.queryParamMap.get('step');
    const faType = route.queryParamMap.get('faType');
    const faParentAppId = route.queryParamMap.get('faParentAppId');

    const ignoredIds = ['null', 'undefined', 'clear'];

    if (id && !ignoredIds.includes(id)) {
      return this.salesService.retrievePartial(id).pipe(
        take(1),
        mergeMap(data => {
          return of({
            id,
            data,
            step,
            faType,
            faParentAppId
          });
        })
      );
    }
    return of({
      id,
      data: null,
      step
    });
  }
}
